import React from "react";
import { MoneyFormat, upperCase } from "../../libs";

function CardTool({ props }) {
  const { media } = props;
  return (
    <div className="card-tools cursor-pointer  lg:w-52 lg:h-62">
      {/* <div name="header-section" className="flex justify-end items-center">
        <div className="flex items-center">
          <img
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_star.svg"}
            alt="icon-star"
          />
          <p className="m-0 colors-gray ml-1 text-sm">5</p>
        </div>
      </div> */}
      <div className="flex justify-center w-full">
        <div className="w-full h-28 p-2">
          <img
            className="w-full h-28 object-cover rounded-lg"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/image/img_empty.png"; // some replacement image
            }}
            src={process.env.REACT_APP_BACKEND_URL + "/storage/" + media.image}
            alt="img-media"
          />
        </div>
      </div>
      <div className="mt-3 p-3 lg:p-4">
        <p className="header-title-semi  font-semibold colors-blue text-sm lg:text-md m-0 truncate ">
          {upperCase(media?.name ?? "Media Reagensia")}
        </p>
        <div className="flex justify-between items-center mt-2">
          <p className="header-content colors-orange m-0 font-semibold text-xs">
            {"Rp. " + MoneyFormat(Number(media.harga))}
          </p>
          <div
            className={`rounded p-1 ${
              media.status === 1
                ? "colors-green-young"
                : media.status === 3
                ? "colors-yellow-young"
                : "colors-red-young"
            } `}
          >
            <p
              className={`m-0 header-title-semi font-semibold text-xs header-content ${
                media.status === 1
                  ? "text-green-800"
                  : media.status === 3
                  ? "text-yellow-800"
                  : "text-red-800"
              }`}
            >
              {media.status === 1
                ? media.status_text
                : media.status === 3
                ? media.status_text
                : media.status_text}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardTool;
